import { Request, } from '../utils';

export const getMeetingSummaryFields = async (data) => {
  const attendance = await Request.get('scheduler/meeting/attendance-type');
  const serviceProvider = await Request.get('scheduler/meeting/service-provider');
  const formProvider = await Request.get('scheduler/meeting/form-provider');
  const nextMeeting = await Request.get('scheduler/meeting/next-meeting-type');
  const meetingLanguage = await Request.get('scheduler/meeting/meeting-language');
  const meetingType = await Request.get('scheduler/counselor/meeting-reason-type');
  const deleteReasons = await Request.get('scheduler/meeting/delete-responses');
  return { attendance, serviceProvider, nextMeeting, meetingLanguage, formProvider, meetingType, deleteReasons };
};

export const saveMeetingSummary = async (data, method) => {
  const result = await Request[method]('scheduler/meeting/meeting-summary', data);
  return result;
}

export const getMeetingSummary = async (data) => {
  const result = await Request.get('scheduler/meeting/meeting-summary', data);
  return result;
}


export const deleteMeeting = async ({ deleteType, meetingId }) => {
  const result = await Request.del(`scheduler/meeting/counselor-student-meeting?deleteType=${deleteType}&meetingId=${meetingId}`,);
  return result;
}

export const getOutstandingTasks = async () => {
  const result = await Request.get('scheduler/meeting/outstanding-task',);
  return result;
}

export const deleteNotification = async () => {
  const result = await Request.post('/scheduler/meeting/outstanding-task/set-availability',);
  return result;
}
export const updateNote = async (data) => {
  const result = await Request.patch('scheduler/appointment-detail', data);
  return result;
}